import { FormattedMessage } from 'react-intl'
import { Button, DialogConfirmation } from '@carto/meridian-ds/components'

function DisableViewerCredentialsConfirmation({
  onCancel,
  onConfirm
}: {
  onCancel: () => void
  onConfirm: () => void
}) {
  return (
    <DialogConfirmation
      opened={true}
      title={<FormattedMessage id="connections.shareDialog.requiresViewerCredential.disablingViewerCredentialsTitle" />}
      actions={
        <>
          <Button variant="text" onClick={onCancel}>
            <FormattedMessage id={'common.button.cancel'} />
          </Button>
          <Button variant="contained" onClick={onConfirm}>
            <FormattedMessage id={'connections.shareDialog.confirm'} />
          </Button>
        </>
      }
    >
      <FormattedMessage id="connections.shareDialog.requiresViewerCredential.disablingViewerCredentials" />
    </DialogConfirmation>
  )
}

export default DisableViewerCredentialsConfirmation
